import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { get, map } from 'lodash';
import { ComponentType, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'src/common/store';
import { getApplicationStats } from 'src/thunks/application-thunks';
import { StatisticsCard } from './statistics-card';
import { StatisticsItemProps } from './statistics-card/statistics-card';
import useStyles from './styles';

export const Statistics: ComponentType = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const stats = useSelector((state: State) => state.application.stats);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getApplicationStats());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const diffPercent = (data: Record<string, any>) => {
    if (!data) return 0;

    const today = get(data, 'allToday');
    const yesterday = get(data, 'allYesterday');

    if (yesterday === 0) return today * 100;

    return (today * 100) / yesterday - 100;
  };

  const data = [
    {
      icon: '/assets/gradient-icons/pages-add.svg',
      label: t('totalApplications', 'Всего заявок'),
      value: get(stats, 'data.applications.all'),
      diffPercent: diffPercent(get(stats, 'data.applications')) || 0,
      today: get(stats, 'data.applications.allToday'),
    },
    {
      icon: '/assets/gradient-icons/page-star.svg',
      label: t('totalCertificates', 'Выдано сертификатов'),
      value: get(stats, 'data.certificates.all'),
      diffPercent: diffPercent(get(stats, 'data.certificates')) || 0,
      today: get(stats, 'data.certificates.allToday'),
    },
    {
      icon: '/assets/gradient-icons/pages-remove.svg',
      label: t('totalDeclined', 'Отклонено'),
      value: get(stats, 'data.declined.all'),
      diffPercent: diffPercent(get(stats, 'data.declined')) || 0,
      today: get(stats, 'data.declined.allToday'),
    },
    // {
    //   icon: '/assets/gradient-icons/warning.svg',
    //   label: t('totalAppeals', 'Подано апелляций'),
    //   value: get(stats, 'data.appeals.all'),
    //   diffPercent: diffPercent(get(stats, 'data.appeals')) || 0,
    //   today: get(stats, 'data.appeals.allToday'),
    // },
  ];

  return (
    <Box className={classes.root} mb={10}>
      <Grid container spacing={2}>
        {map(data, (item: StatisticsItemProps, index: number) => (
          <Grid item key={index} xs={12} sm={6} md={4}>
            <StatisticsCard item={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
